import api from "@v2/lib/api";
import { PLPResponse, PLPSearchParams } from "./types";
import { buildProductListParams } from "./productListParams";

export async function getProductListClient(searchParams: PLPSearchParams, dataOnly: boolean = false): Promise<PLPResponse> {
	const baseApi = dataOnly ? api.plp_data_only : api.plp;
	const response = await fetch(baseApi + "?" + buildProductListParams(searchParams).toString());
	if (!response.ok) throw new Error("Failed to fetch PLP data");
	return await response.json();
}
